module.exports = __webpack_public_path__ + "static/media/trash.fd8b42e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/trash.svg
// module id = 89
// module chunks = 0